import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { User } from './_models';
import { traductionsKeysEnum } from 'src/assets/i18n/traductionsKeysEnum';
@Component({
   selector: 'app-root',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.scss']
})
export class AppComponent {
   title = 'AdBot';
   user: User;

   constructor(private translate: TranslateService) {
      // translate.addLangs(['en', 'fr', 'es']);
     
      // const browserLang = navigator.language || navigator['userLanguage'];
      // console.log('Browser Language:', browserLang);
      
      // this.authenticationService.user.subscribe(x => this.user = x);
      if (localStorage.getItem('currentLanguage')) {
         translate.setDefaultLang(localStorage.getItem('currentLanguage'));
         translate.use(localStorage.getItem('currentLanguage'));
      }else{
         translate.setDefaultLang('fr');
      }
   }
}

